import { useState } from "react";

import { v4 as uuidv4 } from "uuid";

import { PrimaryButton } from "@components/v2";

import { useUniversalBenchmarksConfiguratorContext } from "../../hooks";

import { MetricCard } from "./metric-card";
import { MetricModal } from "./metric-modal";

export const AdjustForIncrementality = () => {
  const { baselineFilters, kpiMetricsData, setBaselineFilters } =
    useUniversalBenchmarksConfiguratorContext();

  const [isMetricModalOpen, setIsMetricModalOpen] = useState(false);

  return (
    <div className="py-6 pl-6 pr-3">
      <h3 className="text-base font-semibold">Add custom benchmark</h3>
      <p className="text-sm text-v2-secondary mb-0.5">
        Remove days that don’t meet a KPI tracked in Northbeam. For example:
      </p>
      <ul className="list-disc pl-6 text-sm text-v2-secondary">
        <li>
          Exclude days that don’t meet a platform-specific ROAS target proven to
          be incremental.
        </li>
        <li>
          Exclude days exceeding a first-time CAC target you know to be
          profitable.
        </li>
      </ul>
      <div className="flex flex-wrap items-center gap-4">
        {baselineFilters.kpiFilters.map((kpiFilter) => {
          const data = kpiMetricsData.find(
            (e) => e.kpiMetricId === kpiFilter.id,
          );

          return (
            <MetricCard
              key={kpiFilter.id}
              kpiFilter={kpiFilter}
              kpiMetricsData={data}
              onUpdate={(value) => {
                setBaselineFilters({
                  ...baselineFilters,
                  kpiFilters: baselineFilters.kpiFilters.map((e) =>
                    e.id === kpiFilter.id ? value : e,
                  ),
                });
              }}
              onDelete={() => {
                setBaselineFilters({
                  ...baselineFilters,
                  kpiFilters: baselineFilters.kpiFilters.filter(
                    (e) => e.id !== kpiFilter.id,
                  ),
                });
              }}
            />
          );
        })}
      </div>
      <div>
        <PrimaryButton onClick={() => setIsMetricModalOpen(true)}>
          <i className="fa-solid fa-plus"></i>
          ADD METRIC
        </PrimaryButton>
        <MetricModal
          isOpen={isMetricModalOpen}
          onClose={() => {
            setIsMetricModalOpen(false);
          }}
          onSubmit={(value) => {
            const newKpiFilters = [
              ...baselineFilters.kpiFilters,
              {
                id: uuidv4(),
                metricId: value.metricId,
                equation: value.equation,
                value: value.value,
                filters: value.filters,
                attributionModel: value.attributionModel,
                accountingMode: value.accountingMode,
                attributionWindow: value.attributionWindow,
              },
            ];

            setBaselineFilters({
              ...baselineFilters,
              kpiFilters: newKpiFilters,
            });
            setIsMetricModalOpen(false);
          }}
        />
      </div>
    </div>
  );
};
